'use client';

// import { InfoIcon } from 'assets/icons';
import { ImageModal } from 'components/ring-air/ProductSelectionSection/ImageModal';
import { useContext } from 'react';
import FeatureList from './FeatureList';
import ComparePlans from './ComparePlans';
import { OffersModalNewContext } from 'components/shared/OffersModal';
import { DotSpinner } from 'components/shared';
import { useBloodVision } from '../BloodVisionContext';
import styles from './FeatureSection.module.css';

const FeatureSection = () => {
  const ModalClient = useContext(OffersModalNewContext);
  const { isLoading, plans, hasUserProvidedZip, isZipValid } = useBloodVision();
  const hasConfirmedZip = hasUserProvidedZip && isZipValid;

  const openPlanInfoModal = () => {
    ModalClient.set(
      <ImageModal>
        <div className={styles.compareWrapper}>
          <ComparePlans isModal={true} />
        </div>
      </ImageModal>,
    );
    ModalClient.show();
  };

  return (
    <div className={styles.infoSection}>
      <div className={styles.featureSectionHeader}>
        <div className={styles.planTitle}>
          <span>Choose Your Plan</span>
          <p className={styles.planHelperCopy}>
            {hasConfirmedZip
              ? 'Availability and pricing confirmed for your ZIP code'
              : 'Enter ZIP first to confirm availability and pricing'}
          </p>
        </div>
        <button className={styles.infoIconContainer} onClick={openPlanInfoModal}>
          {/* <InfoIcon
              style={{
                width: '1.6rem',
                height: 'auto',
              }}
              fill="#000"
            /> */}
          <span
            style={{
              color: 'rgba(1, 95, 227, 1)',
              textDecoration: 'underline',
              display: 'inline-block',
              fontWeight: '400',
              letterSpacing: '-0.12px',
              width: 'fit-content',
            }}
          >
            View all tests
          </span>
        </button>
      </div>
      {isLoading && (!plans || plans.length === 0) ? (
        <div className={styles.loadingIndicator}>
          <DotSpinner color="rgba(0,0,0,0.5)" />
        </div>
      ) : null}
      <FeatureList />
    </div>
  );
};

export default FeatureSection;
